<!-- <div
  *ngIf="loading || saving"
  style="
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  "
>
  <app-loader [is_show_loader]="true"></app-loader>
</div>
 -->
<div>
  <div *ngIf="loading" id="loader-container">
    <div style="display: flex; flex-direction: column; align-items: center">
      <!-- <app-loader [is_show_loader]="true"></app-loader> -->
      <mat-card
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 300px;
          flex-direction: column;
        "
        class="mat-elevation-z0"
      >
        <mat-progress-spinner color="primary" mode="indeterminate">
        </mat-progress-spinner>
      </mat-card>
    </div>
  </div>
</div>

<!-- <app-loader [is_show_loader]="is_show_loader"></app-loader> -->

<!-- <div style="margin-top: 35px; text-align: center" *ngIf="loading && base">
  <span style="color: #d31346; width: 150px; font-size: 200%; font-weight: 900">
    Loading '{{ currentBaseScenario }}' Base Scenario data
  </span>
</div> -->
<!-- <div style="margin-top: 35px; text-align: center" *ngIf="loading && child">
  <span style="color: #d31346; width: 150px; font-size: 200%; font-weight: 900">
    Loading '{{ childScenarioName }}' Child Scenario data
  </span>
</div>
<div style="margin-top: 35px; text-align: center" *ngIf="saving">
  <span style="color: #d31346; width: 150px; font-size: 200%; font-weight: 900">
    Saving '{{ scenarioNameToSave }}' Child Scenario
  </span>
</div> -->
<!-- <div  style="height: 20px; width: 100%"></div> -->

<div class="base-scenario wrapper" style="margin-bottom: 11px">
  <mat-accordion>
    <mat-expansion-panel disabled expanded="false" hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title
          style="
            color: black;
            display: grid;
            grid-template-columns: 1.5fr 0.4fr 0.7fr 0.6fr 0.7fr;
            grid-column-gap: 10px;
          "
          class="new-header"
        >
          <div>
            <span> Base Scenario Name : &nbsp; </span>
            <span class="bold-big-header-montserrat" style="color: #df2020">
              {{ baseScenarioName }}
            </span>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div *ngIf="!loading" class="wrapper">
  <div *ngIf="!loading" class="sb-cont">
    <div class="sb-top">
      <div style="display: flex">
        <img
          src="../../../assets/icons/summary-table-icon.svg"
          alt="icon"
          width="19px"
          height="13px"
        />
        <span class="title-name">Scenario Details</span>
      </div>
      <mat-divider style="margin-top: 10px; margin-bottom: 20px"></mat-divider>
      <div class="form-group">
        <div class="form name selectBoxContainer">
          <label>Scenario Name:</label>
          <input
            matInput
            appearance="outline"
            type="text"
            #scenarioName
            maxlength="30"
            [(ngModel)]="childScenarioName"
            (change)="trimSpace()"
            [disabled]="disabledit"
            placeholder="Insert Scenario Name"
          />
        </div>
        <!-- <div class="form name selectBoxContainer">
          <label>Comments:</label>
          <textarea matInput rows="5" [(ngModel)]="comments"></textarea>
        </div> -->
        <!-- <div class="form name selectBoxContainer">
          <label>Base Scenario Name:</label>
          <input
            type="text"
            disabled
            [(ngModel)]="baseScenarioName"
            placeholder="Enter Base Scenario"
          />
        </div> -->

        <div class="form price">
          <!-- <label class="inflation">Inflation % </label>
          <img src="../../../assets/icons/info-icon.svg" width="11px" height="11px" style="margin-left: 10px;" />
          <input
            matInput
            type="number"
            #x
            class="inflaIn"
            [ngModel]="inflation"
            (focusout)="nextPrice(x.value, y.value)"
            required
          />
          <label class="inflation" style="margin-left: 20px;">Denomination</label>
          <img src="../../../assets/icons/info-icon.svg" width="11px" height="11px" style="margin-left: 10px;"/>
          <input
            matInput
            type="number"
            step="0.05"
            min="0"
            #y
            class="inflaIn"
            [ngModel]="demoniation"
            (focusout)="nextPrice(x.value, y.value)"
            required
          /> -->
          <!-- <div>
            <button
              mat-button
              type="button"
              [disabled]="undoStack.length === 0"
              (click)="undoStep()"
            >
              <img
                src="../../../assets/icons/icon _undo_red.svg"
                width="18px"
                height="18px"
              />
              <span class="undo-redo-btn">UNDO</span>
            </button>
            <button
              type="button"
              mat-button
              [disabled]="redoStack.length === 0"
              (click)="redoStep()"
            >
              <img
                src="../../../assets/icons/icon _undo_ black.svg"
                width="18px"
                height="18px"
                style="margin-left: 10px"
              />
              <span class="undo-redo-btn">REDO</span>
            </button>
          </div> -->
          <div>
            <!-- <button
              mat-raised-button
              type="button"
              class="save-btn"
              (click)="save(scenarioName.value)"
            >
              Save
            </button> -->
            <!-- <span>
            <span
              *ngIf="currentPath == 'addChildScenario' || getUndoStackSize() >= 1"
              ><button mat-raised-button class="save-btn" disabled
                >RUN</button
              ></span
            >
            <span
              *ngIf="currentPath != 'addChildScenario' && getUndoStackSize() < 1"
              ><button
                mat-raised-button
                class="save-btn"
                role="button"
                (click)="runScenario()"

                >RUN</button
              ></span
            >
          </span> -->
          </div>
        </div>
      </div>
      <div class="file-upload-download-container">
        <div class="custom-container">
          <div class="custom-header">
            <h3>Pack Simulation</h3>
          </div>
          <div class="custom-content">
            <form>
              <!-- Single Dropdown -->
              <mat-form-field appearance="outline" class="dropdown-field">
                <mat-label>Select an Option</mat-label>
                <mat-select
                  [(value)]="selectedOption"
                  (selectionChange)="onOptionSelect($event.value)"
                >
                  <mat-option *ngFor="let option of options" [value]="option">{{
                    option
                  }}</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Action Buttons -->
              <!-- <div class="action-buttons">
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="!selectedOption"
                  (click)="onDownload()"
                >
                  <mat-icon>download</mat-icon> Download Excel
                </button>
                <button
                  mat-raised-button
                  [disabled]="!selectedOption || !downloaded"
                  (click)="fileInput.click()"
                >
                  <mat-icon>upload</mat-icon> Upload Excel
                </button>
                <input
                  type="file"
                  #fileInput
                  style="display: none"
                  (change)="onFileUpload($event)"
                />
              </div> -->

              <!-- Action Buttons -->
              <div class="action-buttons">
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="isDownloadLoading || !selectedOption"
                  (click)="onDownload()"
                >
                  <mat-icon *ngIf="!isDownloadLoading">download</mat-icon>
                  <!-- <div style="display: flex;">
                    <mat-spinner
                      *ngIf="isDownloadLoading"
                      diameter="20"
                    ></mat-spinner>
                  </div> -->
                  <span *ngIf="isDownloadLoading">Downloading...</span>
                  <span *ngIf="!isDownloadLoading">Download</span>
                </button>
                <button
                  mat-raised-button
                  [disabled]="isUploadLoading || !selectedOption || !downloaded"
                  (click)="fileInput.click()"
                >
                  <mat-icon *ngIf="!isUploadLoading">upload</mat-icon>
                  <mat-spinner
                    *ngIf="isUploadLoading"
                    diameter="20"
                  ></mat-spinner>
                  <span *ngIf="isUploadLoading">Uploading...</span>
                  <span *ngIf="!isUploadLoading">Upload</span>
                </button>
                <input
                  type="file"
                  #fileInput
                  style="display: none"
                  (change)="onFileUpload($event)"
                  [accept]="
                    this.selectedOption === 'New Product Launch'
                      ? '.xlsx'
                      : '.csv'
                  "
                />
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- <div style="flex-grow: 2">
        <label>Note:</label> This is the
        {{ selectedScenarioType }}
        version
      </div> -->
    </div>
    <div class="user">
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <img
            src="../../../assets/icons/price_inc.svg"
            alt="icon"
            width="20px"
            height="17px"
          />
          <span class="title-name">Price Increase Details</span>
        </div>
      </div>
      <mat-divider style="margin-top: 10px"></mat-divider>

      <div class="level">
        <mat-form-field appearance="outline">
          <mat-label>Level</mat-label>
          <mat-select
            disableOptionCentering
            class="selectLevel"
            (selectionChange)="changeLevel($event.value)"
            [value]="levels[0].value"
          >
            <div *ngFor="let column of levels">
              <mat-option value="{{ column.value }}">{{
                periodType === "quarter" && column.name == "Retailer"
                  ? "Region Leader"
                  : column.name
              }}</mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="price-info-table">
        <label class="column_name">Title Name</label>
        <label class="column_name" style="text-align: center"
          >Current Price</label
        >
        <label class="column_name" style="text-align: center">New Price</label>
        <label class="column_name" style="text-align: center"
          >% Price Change</label
        >
      </div>
      <mat-divider style="margin-top: 10px; margin-bottom: 10px"></mat-divider>
      <div class="scrollable">
        <!-- <div class="price-info-table">
          <div class="overall-company">
            <img
              src="../../../assets/icons/overall_company_icon.svg"
              width="6.5px"
              height="17px"
              style="margin-right: 5px"
            />
            <div>Overall</div>
          </div>
          <div class="overall-column">
            {{ overallCurrentPrice | number : "1.2-2" }}
          </div>
          <div class="overall-column">
            {{ overallNewPrice | number : "1.2-2" }}
          </div>
          <div class="overall-column">{{ overallPercentPr }} %</div>
        </div> -->
        <mat-divider
          style="margin-top: 10px; margin-bottom: 10px"
        ></mat-divider>
        <div *ngFor="let leveldata of priceArray; let i = index">
          <div class="price-info-table">
            <div
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
              class="individual-first-column"
            >
              <!-- <img
                src="../../../assets/icons/brand_icon.svg"
                width="11.6px"
                height="14px"
                style="margin-right: 5px"
              /> -->
              <div>{{ priceArray[i]["levelValueData"] }}</div>
            </div>
            <div class="individual-column">
              {{ priceArray[i]["currentPrice"] | number: "1.2-2" }}
            </div>
            <div class="individual-column">
              {{ priceArray[i]["newPrice"] | number: "1.2-2" }}
            </div>
            <div class="individual-column">
              {{ priceArray[i]["percentPrice"] | number: "1.2-2" }} %
            </div>
          </div>
          <mat-divider
            style="margin-top: 10px; margin-bottom: 10px"
          ></mat-divider>
        </div>
      </div>
    </div>
  </div>
  <mat-divider style="margin-top: 10px; margin-bottom: 10px"></mat-divider>

  <div style="position: relative">
    <div
      [ngClass]="{ disabled: isUploadLoading }"
      style="background: #ffffff; border-radius: 10px"
    >
      <div class="change-price-container">
        <div class="dropdown" style="display: flex">
          <div class="dropBtn dropButtonn" (click)="toggleUserInputMenu()">
            Change Price
            <img
              class="dropBtn"
              src="../../../assets/icons/down_arrow.svg"
              alt="filter"
              width="10px"
              height="12.5px"
            />
          </div>

          <div
            id="changePriceDropDown"
            class="dropdown-content form-group"
            style="
              height: 138px;
              background: #fdfdfd;
              box-shadow:
                0px 4px 4px rgba(0, 0, 0, 0.08),
                0px 0px 1px rgba(67, 90, 111, 0.47);
              border-radius: 8px;
              padding: 12px;
              z-index: 200;
            "
          >
            <div class="abs-inc">
              <label>Abs. Increase</label>
              <input
                type="number"
                #a1
                name="value1"
                [(ngModel)]="absolute"
                [step]="0.05"
                (keyup)="format()"
              />
              <button
                type="button"
                (click)="absolutePriceIncrease(a1.value)"
                class="btn btn primary run"
              >
                RUN
              </button>
            </div>
            <div class="abs-inc">
              <label>Percent Increase</label>
              <input
                type="number"
                #b1
                name="value2"
                class="equalP"
                min="-100"
                max="10000"
                [(ngModel)]="percent"
              />
              <button
                type="button"
                class="btn btn primary run"
                (click)="percentagePriceIncrease(b1.value)"
                min="0"
                max="100"
                required
              >
                RUN
              </button>
            </div>
            <div class="form-check">
              <button
                type="button"
                (click)="resetData()"
                class="btn btn-outline-dark nextBtn reset"
              >
                Reset
              </button>
            </div>
          </div>
        </div>

        <div style="display: flex; gap: 12px; align-items: center">
          <div>
            <div class="filterBtn filters-list" (click)="toggleFilterMenu()">
              <img
                class="filterBtn"
                src="../../../assets/icons/filter_icon.svg"
                alt="filter"
                width="10px"
                height="12.5px"
              />
              Filters
              <div class="filterBtn filter-count">
                {{ getAppliedFilters().length }}
              </div>
            </div>
            <div
              id="myFilterDropdown"
              class="dropdown-filter-content form-group"
              style="
                width: 160px;
                height: 138px;
                background: #fdfdfd;
                box-shadow:
                  0px 4px 4px rgba(0, 0, 0, 0.08),
                  0px 0px 1px rgba(67, 90, 111, 0.47);
                padding: 12px;
                overflow-y: scroll;
                z-index: 200;
              "
            >
              <!-- border-radius: 8px; -->
              <div class="dropdown-heading">Filters Applied:</div>
              <div *ngFor="let filter of getAppliedFilters(); let i = index">
                <!-- <div *ngIf="i % 4 !== 0 || i === 0"> -->
                <button disabled class="active-filters">
                  <ng-container
                    *ngIf="
                      periodType === 'quarter' && filter == retailer;
                      else otherThanRetailer
                    "
                  >
                    {{ regionLeader }}
                  </ng-container>
                  <ng-template #otherThanRetailer>
                    {{ filter }}
                  </ng-template>
                  <img
                    src="../../../assets/icons/Arrow.svg"
                    (click)="closeFilterLevel(filter)"
                  />
                </button>
                <!-- </div> -->
                <!-- <div *ngIf="i % 4 === 0 && i !== 0">
                    <button disabled class="active-filters">
                      <ng-container
                        *ngIf="
                          periodType === 'quarter' && filter == retailer;
                          else otherThanRetailer
                        "
                      >
                        {{ regionLeader }}
                      </ng-container>
                      <ng-template #otherThanRetailer>
                        {{ filter }}
                      </ng-template>
                      <span
                        class="fa fa-times"
                        style="width: 10px; height: 10px; color: #de1c4a"
                        (click)="filterActivity($event, filter)"
                      ></span>
                    </button>
                  </div> -->
              </div>
            </div>
          </div>

          <div style="display: flex; gap: 9px">
            <button
              (click)="downloadCSV()"
              class="round-corners"
              mat-raised-button
              color="primary"
            >
              <mat-icon>download</mat-icon>
              <span> Download Excel </span>
            </button>

            <button
              mat-raised-button
              color="primary"
              class="download-button round-corners"
              type="button"
              (click)="files1.click(); a.value = ''"
            >
              <mat-icon>upload</mat-icon>
              Upload Excel
            </button>
          </div>
        </div>
      </div>
      <div>
        <div style="height: 353px; box-sizing: border-box; overflow-y: auto">
          <table
            mat-table
            [dataSource]="dataSource"
            style="width: max-content; min-width: 100%"
            class="builder-table-container"
          >
            <ng-container
              *ngFor="let column of stringCols; let i = index"
              [matColumnDef]="column"
            >
              <!-- sticky -->
              <th
                mat-header-cell
                *matHeaderCellDef
                [ngStyle]="{
                  'width.px': columnWidths[columnDictionary[column]]
                }"
              >
                <div>
                  <div
                    style="width: 100%"
                    class="header-column"
                    title="{{ columnDictionary[column] }}"
                  >
                    <ng-container
                      *ngIf="
                        periodType === 'quarter' &&
                          columnDictionary[column] == retailer;
                        else otherThanRetailer
                      "
                    >
                      {{ regionLeader }}
                    </ng-container>
                    <ng-template #otherThanRetailer>
                      {{ columnDictionary[column] }}
                    </ng-template>
                    <!-- <ng-container *ngIf='columnDictionary[column] !="Retailer"' >
                      {{ columnDictionary[column] }}
                    </ng-container> -->
                    <ng-container *ngIf="column != 'Base_Price'">
                      <mat-icon
                        style="
                          cursor: pointer;
                          width: 18px;
                          height: 18px;
                          font-size: 18px;
                          float: right;
                        "
                        [matMenuTriggerFor]="menu"
                        (click)="setSelectedFilterColumn(column)"
                        >expand_more</mat-icon
                      >
                    </ng-container>
                  </div>

                  <span class="resize-handle"></span>
                </div>
              </th>
              <td
                mat-cell
                class="column-values"
                *matCellDef="let element"
                [ngStyle]="{
                  'width.px': columnWidths[columnDictionary[column]]
                }"
                style="white-space: break-spaces"
              >
                <!-- <div> -->
                <!-- column.includes("price")? element[column] : column.includes("volume")? element[column]: element[column] -->
                <!-- column.includes("percent_change")
                      ? element[column] + " %"
                      : -->
                {{
                  column.includes("Base_Price")
                    ? (element[column] | number: "1.2-2")
                    : element[column]
                }}
                <!-- </div> -->
              </td>
            </ng-container>

            <ng-container
              *ngFor="let column of numCols; let i = index"
              [matColumnDef]="column"
            >
              <th mat-header-cell *matHeaderCellDef>
                <div>
                  <div style="width: 100%; height: 56px" class="header-column">
                    <div style="display: grid; grid-template-rows: 1fr 2px 1fr">
                      <div
                        style="
                          justify-self: center;
                          align-self: auto;
                          align-items: center;
                          justify-content: center;
                        "
                      >
                        {{ column }}
                      </div>
                      <mat-divider></mat-divider>
                      <div>
                        <div
                          *ngFor="
                            let periodKey of this.yearWiseWeeksCols[column]
                          "
                          style="
                            justify-content: center;
                            align-items: center;
                            min-width: 80px;
                            margin-top: 8px;
                          "
                        >
                          <ng-container
                            *ngIf="periodType === 'week'; else quarterBlock"
                          >
                            W{{ periodKey }}
                          </ng-container>

                          <ng-template #quarterBlock>
                            <ng-container
                              *ngIf="periodType === 'quarter'; else monthBlock"
                            >
                              Q-{{ periodKey }}
                            </ng-container>

                            <ng-template #monthBlock>
                              <ng-container
                                *ngIf="periodType === 'month'; else elseBlock"
                              >
                                {{
                                  monthsMapper[periodKey]
                                    ? monthsMapper[periodKey]
                                    : periodKey
                                }}
                              </ng-container>

                              <ng-template #elseBlock>
                                {{ periodKey }}
                              </ng-template>
                            </ng-template>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              <td mat-cell class="column-values" *matCellDef="let element">
                <div
                  style="
                    display: flex;
                    height: 50px;
                    align-items: center;
                    justify-content: center;
                  "
                  class="week-row"
                >
                  <!-- grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); -->
                  <div
                    *ngFor="
                      let singlePeriodData of element['period_data'][column]
                    "
                    style="min-width: 80px"
                  >
                    <!-- {{ singlePeriodData | json}} -->
                    <ng-container
                      *ngFor="let item of singlePeriodData | keyvalue"
                    >
                      {{ item.value | number: "1.2-2" }}
                    </ng-container>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: tableColumns"
              class="'row.index'"
            ></tr>
          </table>
          <!-- <mat-card
            *ngIf="loading"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              height: 300px;
              flex-direction: column;
            "
            class="mat-elevation-z0"
          >
            <mat-progress-spinner color="primary" mode="indeterminate">
            </mat-progress-spinner>
            <h4 style="font-weight: bold; margin-top: 10px">Loading...</h4>
          </mat-card> -->
          <mat-menu
            #menu="matMenu"
            (closed)="dynamicFilter(false)"
            class="my-menu-list"
          >
            <div *ngIf="!dynamicFilterLoading" class="filter-container">
              <input
                #inputSearch
                class="form-control"
                placeholder="search"
                (click)="$event.stopPropagation()"
                (keyup)="filterColumnValues($event, $event.target.value)"
              />
              <div class="unique">
                <label>
                  <div class="filter-item">
                    <input
                      type="checkbox"
                      [checked]="allSelected[selectedFilterColumn]"
                      (click)="toggleAllSelectFilter($event)"
                    />
                    <p>Select All</p>
                  </div>
                </label>
                <label style="cursor: pointer">
                  <div
                    class="filter-item"
                    *ngFor="let filter of columnFilters[selectedFilterColumn]"
                  >
                    <input
                      type="checkbox"
                      [checked]="checkFilter(filter)"
                      (click)="applyFilter($event, filter)"
                    />
                    <p>
                      {{ filter }}
                    </p>
                  </div>
                </label>
              </div>
            </div>
            <div *ngIf="dynamicFilterLoading" style="width: 200px">
              <mat-card
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-direction: column;
                  margin-left: auto;
                  margin-right: auto;
                  margin-top: auto;
                  margin-bottom: auto;
                "
                class="mat-elevation-z0"
              >
                <mat-progress-spinner
                  diameter="70"
                  color="primary"
                  mode="indeterminate"
                >
                </mat-progress-spinner>
                <h4 style="font-weight: bold; margin-top: 10px">Loading...</h4>
              </mat-card>
              <!-- <app-loader [is_show_loader]="true"></app-loader> -->
            </div>
          </mat-menu>
        </div>
        <mat-paginator
          [length]="childScenarioTableData?.length"
          [pageSize]="
            childScenarioTableData?.length > 100
              ? 100
              : childScenarioTableData?.length
          "
        ></mat-paginator>
      </div>
    </div>

    <div
      *ngIf="isUploadLoading"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background: rgba(255, 255, 255, 0.8);
      "
    >
      <mat-progress-spinner
        [diameter]="80"
        color="primary"
        mode="indeterminate"
      ></mat-progress-spinner>
      <h5 style="margin-top: 10px">
        Please wait, calculations are in progress...
      </h5>
    </div>
  </div>

  <div
    class="nav-controls"
    style="
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      padding: 10px;
      background: #dedede;
      padding-right: 0px;
    "
  >
    <button
      mat-raised-button
      color="primary"
      (click)="saveChild()"
      class="round-corners"
      style="visibility: hidden"
    >
      <!-- [disabled]="!childDetails.child_name" -->
      Save
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="saveChild()"
      class="round-corners"
      [disabled]="isUploadLoading"
    >
      <!-- [disabled]="childStatus == status[1]" -->
      <!-- [disabled]="!childDetails.child_name" -->
      Save & Run
    </button>
  </div>
</div>

<div style="height: 20px; width: 100%"></div>

<input
  type="file"
  accept=".csv"
  #a
  #files1
  (change)="fileUpload($event)"
  style="visibility: hidden"
  class="hidden"
  placeholder="Upload File"
/>
